module.exports = __webpack_public_path__ + "static/media/pres_pc.38bb5f61.jpg";